import { http } from "@/apps/shared/baseService/config";

class Service {
  list() {
    return http.post("/user/investment/list");
  }
}

export default new Service();
